export const QuestionnaireType = {
  Onboarding: 'Onboarding',
  Full: 'Full',
  Feedback: 'Feedback',
  Calendar: 'Calendar',
  CheckAllergy: 'CheckAllergy',
  WeeklyTreatment: 'WeeklyTreatment',
  Anamnesis: 'Anamnesis',
};
